import { createFeatureSelector, createSelector } from "@ngrx/store";

import { CoreFeatureState } from "../reducers";
import { State as CatalogueState } from "../reducers/catalogue.reducer";
import { Category } from "../../../routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { ArrayService } from "../../services/array.service";

export const coreFeatureState =
  createFeatureSelector<CoreFeatureState>("core_feature");

export const catalogueState = createSelector(
  coreFeatureState,
  (state: CoreFeatureState): CatalogueState => state.catalogue,
);

export const getPending = createSelector(
  catalogueState,
  (state: CatalogueState) => state.pending,
);

export const getErrors = createSelector(
  catalogueState,
  (state: CatalogueState) => state.errors,
);

export const addFinalParent = (children: any[], parent: any): any[] => {
  children = children
    .map((item) => {
      const child = { ...item };
      if (child.id !== parent.id) {
        if (child.parent === null) {
          child.parent = parent;
        } else {
          child.parent = addFinalParent([child.parent], parent)[0];
        }
      }

      if (child.variants && child.variants.length) {
        child.variants = addFinalParent(child.variants, parent);
      }

      if (child.children && child.children.length) {
        child.children = addFinalParent(child.children, parent);
      }

      if (child.products && child.products.length) {
        child.products = addFinalParent(child.products, parent);
      }

      if (child.entity === "product") {
        let toDisplay = child.label;
        let prnt = child.parent;
        while (prnt) {
          toDisplay = prnt.label + " > " + toDisplay;
          prnt = prnt.parent;
        }
      }

      return child;
    })
    .sort((a, b) => +a.position - +b.position);

  return children;
};

export const getCategories = createSelector(
  catalogueState,
  (state: CatalogueState) => {
    const parentCategory: Category = {
      id: 0,
      label: "CATALOGUE",
      slug: "location",
      entity: "page",
      description:
        "Retrouvez l'ensemble du matériel évènementiel de TECHNOMAD AUDIO en location. Diffusion audio, backline, enrouleurs, lumière, etc... Tout est là.",
      children: [],
      parent: undefined,
      products: [],
      position: 0,
    };

    parentCategory.children = addFinalParent(state.entities, parentCategory);

    // console.log(state.entities.length ? [parentCategory] : state.entities);

    return state.entities.length ? [parentCategory] : state.entities;
  },
);

/**
 * Return a flat array of products contained in the provided category or her children (recursively)
 */
const getProductsFromCategory = (category: Category): Product[] => {
  const products = [
    ...category.products,
    ...(category.products
      ? category.products.flatMap((product) => product.variants)
      : []),
    ...(category.children
      ? category.children.flatMap((child) => getProductsFromCategory(child))
      : []),
  ];

  // console.log(category.label, products);

  const uniqueProducts = ArrayService.unique(products, "id");

  return uniqueProducts;
};

export const getProducts = createSelector(
  getCategories,
  (categories) =>
    categories.length ? [...getProductsFromCategory(categories[0])] : [],
  // (categories) => [].concat(...categories.map(category => getProductsFromCategory(category)))
);
